import { TableUtils } from '../../jscaip/TableUtils';
import { GameStateWithTable } from '../../jscaip/state/GameStateWithTable';
import { KamisadoBoard } from './KamisadoBoard';
import { KamisadoPiece } from './KamisadoPiece';
export class KamisadoState extends GameStateWithTable {
    colorToPlay;
    coordToPlay;
    alreadyPassed;
    static isOnBoard(coord) {
        return coord.isInRange(KamisadoBoard.SIZE, KamisadoBoard.SIZE);
    }
    constructor(turn, 
    // The color that needs to be played next
    colorToPlay, 
    // The next coord that has to be played
    coordToPlay, 
    // Did a PASS move have been performed on the last turn?
    alreadyPassed, board) {
        super(TableUtils.copy(board), turn);
        this.colorToPlay = colorToPlay;
        this.coordToPlay = coordToPlay;
        this.alreadyPassed = alreadyPassed;
    }
    isEmptyAt(coord) {
        return this.hasPieceAt(coord, KamisadoPiece.EMPTY);
    }
    allPieceCoords() {
        const l = [];
        for (const coordAndContent of this.getCoordsAndContents()) {
            if (coordAndContent.content !== KamisadoPiece.EMPTY) {
                l.push(coordAndContent.coord);
            }
        }
        return l;
    }
}
